import React from 'react';
import {Activities, Route, Switch, Layout, NavLink} from 'components';
import {capitalize} from 'helpers';
import {RouteComponentProps} from 'types';

export function Router({match: {params}}: RouteComponentProps<{module: string, page: string}>) {
  return (
    <>
      <Layout.Title>{capitalize(params.module)}</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink exact={params.page === 'stats'} to={`/${params.module}/`}>{ capitalize(params.module) }</NavLink>
        <NavLink to={`/${params.module}/stats/`}>Statistics</NavLink>
      </Layout.Topbar.Tabs>
      <Switch>
        <Route path="/:module(activities|routines|habits)/stats/" />
        <Route path="/:module(activities|routines|habits)/" component={Activities.Sidebar} />
      </Switch>
      <main>
        <Switch>
          <Route path="/:module(activities|routines|habits)/add/">
            {({match: {params}}: RouteComponentProps) => <Activities.Single.EditForm {...params} />}
          </Route>
          <Route path="/:module(activities|routines|habits)/add-daily-ritual/">
            {({match: {params}}: RouteComponentProps) => <Activities.Single.EditForm {...params} defaultType="routine" dailyRoutineType="daily_routine" />}
          </Route>
          <Route path="/:module(routines|habits)/:page(stats)/" component={Activities.Stats.RoutinesStats} />
          <Route path="/:module(activities)/:page(stats)/" component={Activities.Stats.ActivitiesStats} />
          <Route path="/:module(activities|routines|habits)/:id/" component={Activities.Single.Router} />
          <Route path="/:module/tracking/:id/" component={Activities.Single.Router} />
          <Route path="/:module(habits)/" component={Activities.Single.SelectCategory} />
          <Route path="/:module(activities|routines)/" component={Activities.Home} />
        </Switch>
      </main>
    </>
  );
}
